<form [formGroup]="passwordForm">

  <!-- new password -->
  <div class="password-container">

    <uw-password [label]="passwordLabel" formControlName="password" (blur)="onTouched()"></uw-password>

    @if (passwordForm.get('password')?.touched && passwordForm.get('password')?.hasError(
      'required'
      )) {
      <mat-error class="error-message">
        {{ "messages.field_is_required" | translate }}
      </mat-error>
    }

  </div>

  <!--Confirm Password-->
  <div class="password-container">
    <uw-password label="{{'auth.confirm_password' | translate}}" formControlName="confirmPassword" (blur)="onTouched()"
      [passwordStrengthEnabled]="false">
    </uw-password>

    @if (passwordForm?.touched &&
      passwordForm?.hasError(
      'passwordMismatch'
      )
      ) {
      <mat-error class="error-message">
        {{ "auth.password_not_same" | translate }}
      </mat-error>
    }

    @if (passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.hasError(
      'required'
      )) {
      <mat-error class="error-message">
        {{ "messages.field_is_required" | translate }}
      </mat-error>
    }
  </div>

</form>